import { P } from '@ahmdigital/ui';
import React from 'react';

const RequiredFieldsDisclaimer = () => <P>All fields marked with * are required</P>;

export default RequiredFieldsDisclaimer;
